var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThiredSectionBgLineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390,
    height: 1122,
    viewBox: "0 0 390 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428",
    transform: "translate(0 -1544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M0,0H390V1100.094H0Z",
    transform: "translate(0 1544)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_529",
    "data-name": "Line 529",
    y2: 915,
    transform: "translate(359 1751)",
    fill: "none",
    stroke: "#b6b6b6",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThiredSectionBgLineMobile);
export default __webpack_public_path__ + "static/media/thiredSectionBgLineMobile.dd80451f130338c61684c78fe606303a.svg";
export { ForwardRef as ReactComponent };